<template>
	<div>
		<div>
			<!-- 副导航 -->
			<c-r-m-nav-cell
				ref="navcell" 
				:crm-type="crmType" 
				route-type="index"/>
			
			<!-- 筛选 -->
			<div class="shitu-box">
				<c-r-m-list-head
					ref="listHead" 
					:crm-type="crmType" 
					:actiontype="actiontype"
					:scene_id="scene_id"
					@on-handle="listHeadHandle"/>
				
				<c-r-m-option-button
					ref="search" 
					:crm-type="crmType" 
					:searchtype="searchtype"
					:actiontype="actiontype"
					:exporttype="exporttype"
					:filter-arr="filterArr"
					:scene_id="scene_id"
					@on-handle="optionHandle"
					@save-handle="saveHandle"
					@on-search="searchHandle"
					@on-height-search="heightSearchHandle"
					@listRefresh="listRefresh"/>
			</div>
			<!-- 信息 -->
			<div v-loading="loading" class="abctable">
				<c-r-m-table-head
					ref="crmTableHead"
					:crm-type="crmType"
					:actiontype="actiontype"
					:show-hegiht-search="true"
					@exportData="exportData"
				    @filter="handleFilter"
					@handle="handleHandle">
				</c-r-m-table-head>
				<el-table
					v-show="!loading"
					id="crm-table"
					:data="list" 
					class="n-table--border"
					:cell-style="cellStyle"
					stripe
					size="mini"
					style="width: 100%"
					:header-cell-style="{'background-color':'#f6faff'}" 
					@row-click="handleRowClick"
					@sort-change="sortChange"
					@selection-change="handleSelectionChange">
					<template slot="empty"> 
						<el-empty description="暂无数据"></el-empty>
					</template>
					<el-table-column
						v-if="fieldList.length > 0"
						show-overflow-tooltip
						type="selection"
						align="center"
						width="45"/>
					<el-table-column
						v-if="fieldList.length > 0"
						width="35"
						show-overflow-tooltip>
						<template
							slot-scope="scope">
							<i 
								v-if="scope.row.isfocus == 1"
								class="el-icon-star-on customer-lock icon"
								@click="focus({is_focus:2,customer_id:scope.row.id})"></i>
							<i
								v-else
								class="el-icon-star-off icon"
								@click="focus({is_focus:1,customer_id:scope.row.id})"></i>	
						</template>
					</el-table-column>
					<el-table-column
						v-for="(item, index) in fieldList"
						v-if="item.prop == 'name'"
						:key="index"
						:prop="item.prop"
						:label="item.label"
						:formatter="fieldFormatter"
						sortable="custom">
					</el-table-column>
					<el-table-column
						v-else-if="item.prop == 'log'"
						:key="index"
						:prop="item.prop"
						:label="item.label"
						:formatter="fieldFormatter"
						sortable="custom">
						<template slot-scope="scope">
							{{scope.row[item.prop] ? scope.row[item.prop] : '--'}}
							<el-link
								v-show="scope.row[item.prop+'_count'] > 1"
								slot="reference"
								style="margin-right: 10px;"
								type="primary" 
								@click="moreLog(scope.row.id)">
								更多<i class="el-icon-view el-icon-d-arrow-right"></i>
							</el-link>
						</template>
					</el-table-column>
					<el-table-column
						v-else
						:key="index"
						:prop="item.prop"
						:label="item.label"
						:formatter="fieldFormatter"
						sortable="custom">
						<template
						  slot="header"
						  slot-scope="scope">
						  <div class="table-head-name">{{ scope.column.label }}</div>
						</template>
					</el-table-column>
					<!-- 操作 -->
					<el-table-column
						align="center"
						label="操作"
						width="55"
						v-if="fieldList.length > 0">
							<template slot-scope="scope">
								<el-link
									type="primary"
									v-if="allAuth.customer && allAuth.customer.read"
									@click="handleAction({'type':'read','data':scope.row})">查看</el-link>
								<el-link
									type="primary"
									v-if="allAuth.customer && allAuth.customer.update"
									@click="handleAction({'type':'update','data':scope.row})">修改</el-link>
							</template>
					</el-table-column>
				</el-table>
				
				<div 
					class="p-contianer" 
					v-if="!loading">
					<el-pagination 
						:current-page="currentPage"
						:page-sizes="pageSizes"
						:page-size.sync="pageSize"
						:total="total"
						class="p-bar"
						layout="total, sizes, prev, pager, next, jumper"
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"/>
				</div>
			</div>
		</div>
		<!-- dialog弹窗 -->
		<dialog-form
			:dialog-visible="dialogForm"
			:title="title"
			ref="crmform"  
			:crm-type="crmType"
			:fields-data = "fieldsData"
			:action="action"
			:form-data="formData"
			@close = "closeDialog"
			@save-dialog="saveDialog">
		</dialog-form>
		
		<!-- 更多日志弹窗 -->
		<dialog-info
			:dialog-visible="dialogInfo"
			:title="titleInfo"
			:id="id"
			:crm-type="crmType"
			@close = "closeDialogInfo">
		</dialog-info>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
	// 公共js
	import table from '../../mixins/table'
	// 组件
	import { DialogForm,DialogInfo } from '@/components/FromData'
	export default {
		name: "app",
		components: {
			DialogForm,
			DialogInfo
		},
		mixins: [table],
		computed: {
			...mapGetters(['allAuth'])
		},
		data() {
			return {
				crmType: 'customer',
				
				// 客户首页  7
				actiontype:26,
				searchtype:20,
				exporttype:33,
				
				// 日志弹窗
				dialogInfo:false,
				titleInfo:'',
				id:0
			}
		},
		
		methods: {
			handleAction(item){
				switch (item.type){
					case "read":
						this.$router.push({
							path:"/customer/read/basicinfo/"+item.data.id
						}) 
						break;
						
					case "update":
						this.title = "修改信息"
						this.dialogForm = true
						this.action = { type: 'update',relevant:"customer",actiontype:16 }
						let items = JSON.parse(JSON.stringify(item.data))
						this.formData = items
						break;
				}
			},
			
			
			// 更多日志
			moreLog(id){
				this.titleInfo = "沟通日志"
				this.id=id
				this.dialogInfo = true
			},
			
			// 关闭日志弹窗
			closeDialogInfo(){
				this.dialogInfo = false
			}
		}
	}
</script>

<style scoped>
	.shitu-box {
		margin-top: 10px;
		padding: 10px;
		background-color: #fff;
		width: 1200px;
		font-size: 15px;
	}
	/deep/ .p-contianer{
		background-color: #fff !important;
		padding:10px
	}
	/deep/ .table-head-name{
		display: inline;
	}
	/deep/ .el-table  {
	  overflow: visible;
	}
	 
	/deep/ .el-table__header-wrapper {
	  position: sticky;
	  top: 50px;
	  z-index: 10;
	}
	.icon, .customer-lock{
		cursor: pointer;
		font-size: 15px;
	}
	.customer-lock {
		color: #f15e64;
	}
	/deep/ .el-link{
		font-size: 12px !important;
	}
	.heise{
		color:#333 !important;
	}
	/deep/ .el-tag{
		/* color:#333 !important; */
		/* width: 85px !important; */
		overflow: hidden;
		text-align: center;
		padding:0 !important
	}
	/deep/ .el-table .el-table__cell {
	    padding: 3px 0 !important;
	}
</style>